<template>
	<v-card>
		<v-card-title>
			<h2>Nowy dokument księgowy</h2>
		</v-card-title>

		<invoice-form
			ref="form"
			:isNew="true"
			:invoice="invoice"
			primary-button-caption="Utwórz"
			@primary-action="create"
			:loading="loading">
		</invoice-form>
	</v-card>
</template>

<script>
	import InvoiceForm from "./components/InvoiceForm";
	import {Invoice} from "../../../api/generated/Invoice";

	export default {
		name: "InvoiceCreateView",

		components: {InvoiceForm},

		data() {
			return {
				invoice: {
					id: null,
					documentName: "",
					documentNumber: "",
					costsSum: 0,
					paymentDates: [],
					actionCosts: [],
				},
				project: {
					id: this.$route.params.projectId,
				},
				loading: false
			};
		},

		created() {
		},

		methods: {
			async create(invoice) {
				if(!this.loading){
				this.loading = true;
				if (await this.$refs.form.validate()) {
					Invoice.post(this, this.project.id, invoice, success => {
						this.$messagesBus.$emit("success", "Pomyślnie utworzono dokument", success);
						this.$router.go(-1);
					}, error => {
						this.loading = false;
						this.$messagesBus.$emit("error", "Nie udało się utworzyć dokumentu", error);
					});
				} else {
					this.loading = false;	
				}
			}
			},
		},
	};
</script>

<style scoped>

</style>
